export default {
  DASHBOARD: {
    TITLE: 'Dashboard',
    FILTERS: {
      DATE: {
        PLACEHOLDER: 'Rango de fechas',
        MONTH: '30 días',
        SEMESTER: '6 meses',
        YEAR: '1 año',
        ALL: 'Desde el inicio',
      },
      SECTOR: { PLACEHOLDER: 'Sector*', HELP: '*El filtro de sector no se aplica a los usuarios, solo sobre los kpi de empresa.' },
      COUNTRY: { PLACEHOLDER: 'País' },
      STATE: { PLACEHOLDER: 'Provincia / Estado' },
    },
    KPI: {
      AVG: '% del total en wokap',
      ENTITY: {
        TITLE: 'Empresas',
        TOTAL_ENTITIES: {
          TEXT: 'Total empresas',
          TOOLTIP: 'Cantidad total de empresas que se han registrado en wokap',
        },
        ACTIVE_ENTITIES: {
          TEXT: 'Activas',
          TOOLTIP: 'Empresas que iniciaron sesión o hicieron alguna acción en el SaaS en el último mes',
        },
        OFFERS_PUBLISHED: {
          TEXT: 'Ofertas publicadas',
          TOOLTIP: 'Cantidad de ofertas que han publicado las empresas',
        },
        AVERAGE_OFFERS_PER_ENTITY: {
          TEXT: 'Media ofertas / empresa',
          TOOLTIP: 'Total ofertas entre total empresas',
        },
        USERS_SUBSCRIBED_TO_OFFERS: {
          TEXT: 'Usuarios inscritos',
          TOOLTIP: 'Cuántos usuarios se han inscrito a las ofertas ',
        },
        AVERAGE_USERS_SUBSCRIBED_TO_OFFERS: {
          TEXT: 'Media usuarios inscritos',
          TOOLTIP: 'Total de usuarios inscritos entre el número de ofertas',
        },
        RETENTION_RATE: {
          TEXT: '% retención',
          TOOLTIP: '% de empresas que siguen activas este último mes vs total empresas',
        },
        SECTOR_MOST_COMMON: {
          TEXT: 'Sectores más comunes',
          TOOLTIP: 'Industria con la mayor presencia',
          XAXIS_TITLE: 'Sectores',
        },
      },
      USER: {
        TITLE: 'Usuarios',
        TOTAL_USERS: {
          TEXT: 'Usuarios registrados',
          TOOLTIP: 'Personas que crearon su cuenta en la app. No todos buscan trabajo activamente',
        },
        ACTIVE_USERS: {
          TEXT: 'Activos',
          TOOLTIP: 'Usuarios que iniciaron sesión o realizaron alguna acción en la app en los últimos 30 días a partir de la fecha seleccionada',
        },
        USERS_APPLIED: {
          TEXT: 'Usuarios aplicaron',
          TOOLTIP: 'Personas que se postularon al menos a una oferta. Reflejan intención laboral activa',
        },
        TOTAL_APPLICATIONS: {
          TEXT: 'Total postulaciones',
          TOOLTIP: 'Número total de veces que los usuarios han aplicado (un usuario puede aplicar varias veces)',
        },
        AVERAGE_APPLICATIONS_PER_USER: {
          TEXT: 'Media postulaciones / usuario',
          TOOLTIP: 'Número de postulaciones dividido entre usuarios que postularon al menos una vez',
        },
        PERCENTAGE_USERS_APPLIED: {
          TEXT: '% inscritos',
          TOOLTIP: '% de usuarios registrados que están buscando empleo activamente',
        },
        FINALIST_APPLICATIONS: {
          TEXT: '% finalistas',
          TOOLTIP: '% de postulaciones que llegaron a la etapa de finalista',
        },
        AGE_AVERAGE: {
          TEXT: 'Edad promedio',
          TOOLTIP: 'Edad media de los usuarios registrados',
        },
        OCCUPATION_MOST_COMMON: {
          TEXT: 'Ocupaciones más comunes',
          TOOLTIP: 'Tipo de trabajo más frecuente entre los usuarios registrados',
          XAXIS_TITLE: 'Ocupaciones',
        },
      },
    },
  },
} as const;
